import React from 'react'

import { BaseText } from '@/components/base'

interface LabelProps {
  type?: 'cardTitle' | 'default' | 'descriptionBottomSheet' | 'titleBottomSheet'
  onPress?: () => void
  skeletonActive?: boolean
  skeletonWidth?: number
  children: React.ReactNode
  centralize?: boolean
}

export const Label: React.FC<LabelProps> = ({
  type = 'default',
  onPress,
  skeletonActive = false,
  skeletonWidth = 100,
  children,
  centralize = false,
}) => {
  if (skeletonActive) {
    return (
      <div
        className="bg-gray-600 animate-pulse rounded"
        style={{ width: `${skeletonWidth}px`, height: '20px' }}
      />
    )
  }

  const getTextProps = () => {
    switch (type) {
      case 'cardTitle':
        return {
          fontSize: 16,
          fontFamily: 'semibold' as const,
          color: 'label.default',
        }
      case 'descriptionBottomSheet':
        return {
          fontSize: 14,
          fontFamily: 'regular' as const,
          color: 'label.description',
        }
      case 'titleBottomSheet':
        return {
          fontFamily: 'semibold' as const,
          fontSize: 28,
          color: 'label.default',
        }
      default:
        return {
          fontSize: 14,
          fontFamily: 'regular' as const,
          color: 'label.default',
        }
    }
  }

  return (
    <BaseText
      {...getTextProps()}
      style={{
        cursor: onPress ? 'pointer' : 'default',
        textAlign: centralize ? 'center' : undefined,
      }}
      onClick={onPress}
    >
      {children}
    </BaseText>
  )
}
